/** Gate 2 — WCAG 2.4.3 focus order / 1.3.2 meaningful sequence helpers */

export const GATE2_MAIN_ID = "gate2-main-content";

export const GATE2_SKIP_TO_MAIN_SX = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0,
  bgcolor: "transparent",
  color: "#005BF0",
  fontFamily: "Lato, sans-serif",
  fontSize: 14,
  fontWeight: 700,
  textDecoration: "none",
  zIndex: 1,
  "&:focus": {
    position: "fixed",
    top: 8,
    left: 8,
    width: "auto",
    height: "auto",
    margin: 0,
    overflow: "visible",
    clip: "auto",
    px: 2,
    py: 1,
    borderRadius: "4px",
    bgcolor: "#005BF0",
    color: "#FFFFFF",
    boxShadow: "0 0 0 2px #FFFFFF, 0 0 0 4px #005BF0",
    outline: "none",
  },
};

export function focusGate2MainContent() {
  const el = document.getElementById(GATE2_MAIN_ID);
  if (el && typeof el.focus === "function") {
    el.focus({ preventScroll: false });
  }
}
